import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { GridComponent } from '@syncfusion/ej2-angular-grids';
import { TreeGridComponent } from '@syncfusion/ej2-angular-treegrid';
@Component({
    selector: 'lib-column-chooser',
    templateUrl: './column-chooser.component.html',
    styleUrl: './column-chooser.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule]
})
export class ColumnChooserComponent {
    @Input('grid') grid!: GridComponent | TreeGridComponent;
    onClick() {
        this.grid?.columnChooserModule?.openColumnChooser(0, 40);
        document.getElementById(this.grid?.element?.id+"_ccdlg_title")?.classList.add('d-none');
    }
}

